interface NFPADiamondProps {
  health: number;
  flammability: number;
  instability: number;
  size?: number;
}

export default function NFPADiamond({
  health,
  flammability,
  instability,
  size = 60,
}: NFPADiamondProps) {
  const half = size / 2;
  const cellSize = half * 0.7;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className="inline-block"
    >
      {/* Flammability (top - red) */}
      <polygon
        points={`${half},${half - cellSize} ${half + cellSize},${half} ${half},${half} ${half - cellSize},${half}`}
        fill="#ef4444"
        stroke="#dc2626"
        strokeWidth="1"
      />
      <text
        x={half}
        y={half - cellSize / 3}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="white"
        fontSize={size * 0.18}
        fontWeight="bold"
      >
        {flammability}
      </text>

      {/* Health (left - blue) */}
      <polygon
        points={`${half - cellSize},${half} ${half},${half} ${half},${half + cellSize} ${half - cellSize},${half}`}
        fill="#3b82f6"
        stroke="#2563eb"
        strokeWidth="1"
      />
      <text
        x={half - cellSize / 3}
        y={half + cellSize / 3}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="white"
        fontSize={size * 0.18}
        fontWeight="bold"
      >
        {health}
      </text>

      {/* Instability (right - yellow) */}
      <polygon
        points={`${half},${half} ${half + cellSize},${half} ${half},${half + cellSize}`}
        fill="#eab308"
        stroke="#ca8a04"
        strokeWidth="1"
      />
      <text
        x={half + cellSize / 3}
        y={half + cellSize / 3}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="#1f2937"
        fontSize={size * 0.18}
        fontWeight="bold"
      >
        {instability}
      </text>
    </svg>
  );
}
